// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Company var Styles */
:root {
  
  --local-com-bg-color: rgba(0, 0, 0, 0.6);
}


.scl--mai-com-bx-cont-st{
  width: 100%;
}

/* Hero Section */
.scl--web-page-company-hero-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100vh;
  max-height: 1212px;
  background: #000000;
  position: relative;
  overflow: hidden;
}

.scl--wpchs-con-st {
  width: 100%;
  display: flex;
  justify-content: center;
}

.scl--web-page-company-hero-section .scl--web-component-hero-content {
  max-width: var(--global-desktop-width-resp);
  padding-left: var(--global-desktop-padding-left);
}

.scl--web-page-company-hero-section .scl--web-component-hero-content button{
  background: linear-gradient(180deg, #181818 0%, #111111 100%);
  border: 1.5px solid #252525;
}

.scl--web-page-company-hero-section .scl--web-component-hero-content button:hover{
  border: 1px solid white;
}

.scl--web-page-company-hero-section .scl--web-component-hero-content  .scl--web-component-hero-title{
  max-width: 800px;
}

.scl--web-page-company-gradient-overlay {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  z-index: 1;
  display: flex;
  justify-content: end;
}

/* Our Value Section */
.scl--web-page-company-our-value-section {
  width: 100%;
  display: flex;
  justify-content: center;
  background: linear-gradient(0.67deg, rgba(0, 0, 0, 0.6) 2.35%, #000000 98.73%);
  max-height: 1308px;
  padding-top: 81px;
}

.scl--wpcovs-cons-resp-str{
  width: 100%;
  max-width: var(--global-desktop-width-resp);
  display: flex;
  flex-direction: column;
  align-items: center;
   
}

.scl--wpcovs-se-con-str {
  width: 100%;
  padding-bottom: 50px;
  display: flex;
  justify-content: center;
}

.scl--wpcovs-se-con-str .scl--stv-con-bo-str{
  width: 100%;
  max-width: var(--global-desktop-width-resp);
  padding-left: var(--global-desktop-padding-left);
  padding-right: var(--global-desktop-padding-right); 
}

.scl--web-page-company-our-value-content {
  width: 100%;
  height: 819px;
}

.scl--web-page-company-our-value-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.scl--web-page-company-our-principle-section {
  width: 100%;
  min-height: 1094px;
  padding-bottom: 100px;
  background-color: var(--local-com-bg-color);
  display: flex;
  justify-content: center;
}

.scl--wpcops-bo-cont-str-compl{
  width: 100%;
  max-width: var(--global-desktop-width-resp);
  padding-left: var(--global-desktop-padding-left);
  padding-right: var(--global-desktop-padding-right);
}

.scl--web-page-company-our-principle-section .scl--wpcops-con-sec-str {
  margin-top: 140px;
  gap: 0px;
}

.scl--wpcops-con-sec-str .scl--web-component-section-title-text-container {
  padding-top: 74px;
}

.scl--wpcops-con-sec-str h2 {
  color: var(--color-text-primary);
  font-size: var(--font-size-sub-title-xl);
  line-height: normal;
  font-weight: 500;
}

.scl--wpcops-dc-art-con-str {
  width: 100%;
  margin-top: 130px;
}

.scl--wdacs-st-cont-bo-st {
  display: grid;
  grid-template-columns: repeat(3, minmax(320px, 1fr));
  gap: 16px;
}

.scl--wdacs-bo-car-con-st {
  width: 100%;
  height: auto;
}

.scl--web-page-differ-section {
  width: 100%;
  min-height: 1207px;
  padding-bottom: 100px;
  background-color: var(--local-com-bg-color);
  display: flex;
  justify-content: center;
}

.scl--wpds-resp-con-stl{
  width: 100%;
  max-width: var(--global-desktop-width-resp);
  padding-left: var(--global-desktop-padding-left);
  padding-right: var(--global-desktop-padding-right);
}

.scl--web-page-differ-section .scl--web-component-section-title-container {
  gap: 0px;
}

.scl--web-page-differ-section .scl--wpcops-dc-art-con-str .scl--wdacs-st-cont-bo-st{
  display: grid;
  grid-template-columns: repeat(2, minmax(320px, 1fr));
  gap: 16px;
}

.scl--web-page-differ-section .scl--wdacs-bo-car-con-st:first-child .scl--dca-con-bo-str.border-left{
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}

.scl--wpchs-tal-con-str {
  width: 100%;
  min-height: 1072px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 150px;
}

.scl--step-img-comp-bo-const-stl{
  width: 100%;
  margin-top: 75px;
}

.scl--step-img-comp-bo-const-stl img{
  width: 100%;
  height: 819px;
  object-fit: cover;
}

.scl--wpchs-tal-con-str .scl--scbs-sec-ti-con-bo-str .sc--sstcbs-pa-str{
  width: 400px;
}

.scl--wtcs-nea-fo-lin-dcl-st{
  width: 100%;
  max-width: var(--global-desktop-width-resp);
  display: flex;
  flex-direction: column;
  gap: 150px;
}

.scl--wtcs-ti-con-st {
  padding-left: var(--global-desktop-padding-left);
  padding-right: var(--global-desktop-padding-right);
}

.scl--wtcs-stl-dcl-cont {
  width: 100%;
}

.scl--web-page-ctac-section {
  width: 100%;
  min-height: 1207px;
  background-color: var(--local-com-bg-color);
  display: flex;
  justify-content: center;
}

.scl--wpcs-cont-stl-bo{
  width: 100%;
  max-width: var(--global-desktop-width-resp);
  padding-left: var(--global-desktop-padding-left);
  padding-right: var(--global-desktop-padding-right);
}

.scl--web-page-ctac-section .scl--web-component-section-title-text {
  line-height: normal;
  font-size: var(--font-size-sub-title-xl);
  font-weight: 500;
}

.scl--web-page-ctac-section .scl--wpctacs-con-sec-str {
  gap: 0px;
}

.scl--web-page-ctac-section .scl--web-component-section-title-text-container {
  margin-top: 74px;
}

.scl--wpctas-dc-art-con-str{
  width: 100%;
  margin-top: 130px;
}

.scl--wpctas-dc-art-con-str .scl--wpctas-bo-car-con-st:not(:last-child) {
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.scl--wpctas-st-cont-bo-st{
  display: grid;
  grid-template-columns: repeat(3, minmax(200px, 1fr));
  gap: 35px;
}

.scl--mai-com-bx-cont-st .scl--web-component-section-description-text{
  color: var(--color-text-third);
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/company/css/company.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;;EAEE,wCAAwC;AAC1C;;;AAGA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,gDAAgD;AAClD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,8EAA8E;EAC9E,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;EAC3C,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;EAC3C,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["/* Company var Styles */\n:root {\n  \n  --local-com-bg-color: rgba(0, 0, 0, 0.6);\n}\n\n\n.scl--mai-com-bx-cont-st{\n  width: 100%;\n}\n\n/* Hero Section */\n.scl--web-page-company-hero-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100vh;\n  max-height: 1212px;\n  background: #000000;\n  position: relative;\n  overflow: hidden;\n}\n\n.scl--wpchs-con-st {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.scl--web-page-company-hero-section .scl--web-component-hero-content {\n  max-width: var(--global-desktop-width-resp);\n  padding-left: var(--global-desktop-padding-left);\n}\n\n.scl--web-page-company-hero-section .scl--web-component-hero-content button{\n  background: linear-gradient(180deg, #181818 0%, #111111 100%);\n  border: 1.5px solid #252525;\n}\n\n.scl--web-page-company-hero-section .scl--web-component-hero-content button:hover{\n  border: 1px solid white;\n}\n\n.scl--web-page-company-hero-section .scl--web-component-hero-content  .scl--web-component-hero-title{\n  max-width: 800px;\n}\n\n.scl--web-page-company-gradient-overlay {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: #000000;\n  z-index: 1;\n  display: flex;\n  justify-content: end;\n}\n\n/* Our Value Section */\n.scl--web-page-company-our-value-section {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  background: linear-gradient(0.67deg, rgba(0, 0, 0, 0.6) 2.35%, #000000 98.73%);\n  max-height: 1308px;\n  padding-top: 81px;\n}\n\n.scl--wpcovs-cons-resp-str{\n  width: 100%;\n  max-width: var(--global-desktop-width-resp);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n   \n}\n\n.scl--wpcovs-se-con-str {\n  width: 100%;\n  padding-bottom: 50px;\n  display: flex;\n  justify-content: center;\n}\n\n.scl--wpcovs-se-con-str .scl--stv-con-bo-str{\n  width: 100%;\n  max-width: var(--global-desktop-width-resp);\n  padding-left: var(--global-desktop-padding-left);\n  padding-right: var(--global-desktop-padding-right); \n}\n\n.scl--web-page-company-our-value-content {\n  width: 100%;\n  height: 819px;\n}\n\n.scl--web-page-company-our-value-content img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.scl--web-page-company-our-principle-section {\n  width: 100%;\n  min-height: 1094px;\n  padding-bottom: 100px;\n  background-color: var(--local-com-bg-color);\n  display: flex;\n  justify-content: center;\n}\n\n.scl--wpcops-bo-cont-str-compl{\n  width: 100%;\n  max-width: var(--global-desktop-width-resp);\n  padding-left: var(--global-desktop-padding-left);\n  padding-right: var(--global-desktop-padding-right);\n}\n\n.scl--web-page-company-our-principle-section .scl--wpcops-con-sec-str {\n  margin-top: 140px;\n  gap: 0px;\n}\n\n.scl--wpcops-con-sec-str .scl--web-component-section-title-text-container {\n  padding-top: 74px;\n}\n\n.scl--wpcops-con-sec-str h2 {\n  color: var(--color-text-primary);\n  font-size: var(--font-size-sub-title-xl);\n  line-height: normal;\n  font-weight: 500;\n}\n\n.scl--wpcops-dc-art-con-str {\n  width: 100%;\n  margin-top: 130px;\n}\n\n.scl--wdacs-st-cont-bo-st {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(320px, 1fr));\n  gap: 16px;\n}\n\n.scl--wdacs-bo-car-con-st {\n  width: 100%;\n  height: auto;\n}\n\n.scl--web-page-differ-section {\n  width: 100%;\n  min-height: 1207px;\n  padding-bottom: 100px;\n  background-color: var(--local-com-bg-color);\n  display: flex;\n  justify-content: center;\n}\n\n.scl--wpds-resp-con-stl{\n  width: 100%;\n  max-width: var(--global-desktop-width-resp);\n  padding-left: var(--global-desktop-padding-left);\n  padding-right: var(--global-desktop-padding-right);\n}\n\n.scl--web-page-differ-section .scl--web-component-section-title-container {\n  gap: 0px;\n}\n\n.scl--web-page-differ-section .scl--wpcops-dc-art-con-str .scl--wdacs-st-cont-bo-st{\n  display: grid;\n  grid-template-columns: repeat(2, minmax(320px, 1fr));\n  gap: 16px;\n}\n\n.scl--web-page-differ-section .scl--wdacs-bo-car-con-st:first-child .scl--dca-con-bo-str.border-left{\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.scl--wpchs-tal-con-str {\n  width: 100%;\n  min-height: 1072px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 150px;\n}\n\n.scl--step-img-comp-bo-const-stl{\n  width: 100%;\n  margin-top: 75px;\n}\n\n.scl--step-img-comp-bo-const-stl img{\n  width: 100%;\n  height: 819px;\n  object-fit: cover;\n}\n\n.scl--wpchs-tal-con-str .scl--scbs-sec-ti-con-bo-str .sc--sstcbs-pa-str{\n  width: 400px;\n}\n\n.scl--wtcs-nea-fo-lin-dcl-st{\n  width: 100%;\n  max-width: var(--global-desktop-width-resp);\n  display: flex;\n  flex-direction: column;\n  gap: 150px;\n}\n\n.scl--wtcs-ti-con-st {\n  padding-left: var(--global-desktop-padding-left);\n  padding-right: var(--global-desktop-padding-right);\n}\n\n.scl--wtcs-stl-dcl-cont {\n  width: 100%;\n}\n\n.scl--web-page-ctac-section {\n  width: 100%;\n  min-height: 1207px;\n  background-color: var(--local-com-bg-color);\n  display: flex;\n  justify-content: center;\n}\n\n.scl--wpcs-cont-stl-bo{\n  width: 100%;\n  max-width: var(--global-desktop-width-resp);\n  padding-left: var(--global-desktop-padding-left);\n  padding-right: var(--global-desktop-padding-right);\n}\n\n.scl--web-page-ctac-section .scl--web-component-section-title-text {\n  line-height: normal;\n  font-size: var(--font-size-sub-title-xl);\n  font-weight: 500;\n}\n\n.scl--web-page-ctac-section .scl--wpctacs-con-sec-str {\n  gap: 0px;\n}\n\n.scl--web-page-ctac-section .scl--web-component-section-title-text-container {\n  margin-top: 74px;\n}\n\n.scl--wpctas-dc-art-con-str{\n  width: 100%;\n  margin-top: 130px;\n}\n\n.scl--wpctas-dc-art-con-str .scl--wpctas-bo-car-con-st:not(:last-child) {\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.scl--wpctas-st-cont-bo-st{\n  display: grid;\n  grid-template-columns: repeat(3, minmax(200px, 1fr));\n  gap: 35px;\n}\n\n.scl--mai-com-bx-cont-st .scl--web-component-section-description-text{\n  color: var(--color-text-third);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
